import React from 'react';
import { useModalClose } from '../../../../utils/useModalClose';

type Props = {
  close: () => void;
  reject: () => void;
  onConfirm: () => Promise<void>;
};

export const SentToRecipientConfirmationModal: React.FC<Props> = ({
  reject,
  close,
  onConfirm,
}) => {
  const modalRef = useModalClose(reject);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  return (
    <div className="modal-dialog" ref={modalRef}>
      <div className="modal-content">
        <div className="modal-body">
          <div className="d-flex flex-row justify-content-between align-items-center">
            <h3>Подтвердите выдачу посылки</h3>
          </div>
          <div>Перед выдачей посылки, проверьте документы получателя</div>
        </div>
        <div className="modal-footer justify-content-end">
          <button
            type="button"
            className="btn btn-success"
            onClick={async () => {
              setIsSubmitting(true);
              await onConfirm();
              setIsSubmitting(false);
              close();
            }}
          >
            {isSubmitting ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              'Подтвердить'
            )}
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary color-gray-600"
            onClick={() => {
              reject();
            }}
          >
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
};
